import { css } from 'styled-components';
import palette from './palette';

export const newInputStyle = css`
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #fff;
  &::placeholder {
    color: rgba(0, 0, 0, 0.1);
  }
`;

export const inputStyle = css`
  margin-top: 6px;
  padding: 6px 10px;
  border: solid 1px #000;
  border-radius: 8px;
  background: #fff;
  font-size: 12px;
  &::placeholder {
    color: #000;
  }
`;

export const buttonStyle = css`
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  background: ${props => (props.cancel ? palette.theme[0] : palette.theme[3])};
  color: #fff;
  cursor: pointer;
  & + & {
    margin-left: 1rem;
  }
  &:hover {
    background: ${props =>
      props.cancel ? palette.theme[2] : palette.theme[2]};
  }
`;

export const boxStyle = css`
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    background: ${palette.gray[2]};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.gray[5]};
    border-radius: 10px;
  }
`;
